import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: GreenTurtwig
 * id 15DC169E-459C-4EDB-BF8F-3E1D4F34B2BF
 * name bed-empty
 * version: 2.2.43
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bed-empty.svg
 * tags
 * - Home Automation 
 * - Holiday 
 */
export const BedEmptyIcon = createSvgIcon(<><path d="M19,7H5V14H3V5H1V20H3V17H21V20H23V11A4,4 0 0,0 19,7" /></>, 'BedEmptyIcon');
export default BedEmptyIcon